import { Stack } from "@mui/material";
import {
  ApplicationReference,
  ReferenceType,
} from "../../../__generated__/types";

export const StaticReferenceList = ({
  references,
}: {
  references: ApplicationReference[];
}) => {
  return (
    <div>
      {references.map((reference) => {
        const detailLine =
          reference.type === ReferenceType.Client
            ? reference.ProjectType ?? ""
            : reference.businessName ?? "";

        return (
          <Stack spacing={1} className="work-experience-item" key={reference.id}>
            <h4 className="work-experience-title font-body font-size-4">
              {reference.firstName} {reference.lastName}
              {detailLine ? ` - ${detailLine}` : ""}
            </h4>
            <Stack spacing={0}>
              {reference.startDate && reference.endDate && (
                <span className="font-size-3">
                  {reference.startDate}
                  {" - "}
                  {reference.endDate}
                </span>
              )}
              {reference.yearsKnown && (
                <span className="font-size-3">
                  <b>Years Known:</b> {reference.yearsKnown} years
                </span>
              )}
            </Stack>
            <span className="font-size-3">
              <b>Reference Type:</b> {reference.type}
            </span>
            <Stack spacing={0}>
              <span className="font-size-3">
                <b>Email:</b> {reference.email}
              </span>
              <span className="font-size-3">
                <b>Phone:</b> {reference.phoneNumber}
              </span>
            </Stack>
          </Stack>
        );
      })}
    </div>
  );
};
